var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('v-col',{staticClass:"text-center vrij-font",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('b',[_vm._v("Vrijraj Singh")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }